import React, { useEffect, useState } from "react";

import { DateTimeFormatter, Instant, LocalDateTime, nativeJs, ZoneId } from "@js-joda/core";
import { IInstantProps } from "components/dashboard/product-template-table/utils/interfaces";
import { formatDataPatternToCalendar } from "components/dashboard/product-template-table/utils/utils";
import { Calendar } from "primereact/calendar";
import { FormEvent } from "primereact/ts-helpers";
import { DEFAULT_DATE_PATTERN } from "utils/constants";

const InstantComponent = (props: IInstantProps) => {
    const [instant, setInstant] = useState<Instant | undefined>(props.value ? Instant.parse(props.value) : undefined);
    const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const zonedDateTime = instant?.atZone(ZoneId.of(userTimeZone));
    const localDateTime = zonedDateTime?.toLocalDateTime();

    useEffect(() => {
        if (onCalendarFocus === false && instant !== undefined) {
            const utcString = convertDateToUTCString(instant);
            props.changeHandler(utcString)
        }
    }, [onCalendarFocus]);

    const convertDateToUTCString = (date: Instant) => {
       return date.toString();
    }

    const convertDateToFormattedString = (date: LocalDateTime | undefined, formatString: string) => {
        const formatter = DateTimeFormatter.ofPattern(formatString);
        return date?.format(formatter);
    };

    const dateChangeHandler = (e: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
        const date = e.value as Date;
        if (date) {
            setInstant(Instant.from(nativeJs(date)));
            props.changeHandler(date.toISOString())
        }
    }

    const hasHours = () => {
        let has = true;
        if (props.format) {
            has = props.format.split(' ')[1] !== undefined;
        }
        return has;
    }
    const dateFormat = formatDataPatternToCalendar(props.format ?? DEFAULT_DATE_PATTERN)?.split(" ")[0]
    
    if (props.isInEditMode) {
        return <Calendar hourFormat="24"
                         className="w-full"
                         value={instant ? new Date(instant.toEpochMilli()) : undefined}
                         onChange={dateChangeHandler}
                         onFocus={() => setOnCalendarFocus(true)}
                         onHide={() => setOnCalendarFocus(false)}
                         dateFormat={dateFormat}
                         onInput={e => {
                             const val = e.target as HTMLInputElement;
                             if (!val.value) {
                                 setInstant(undefined);
                                 props.changeHandler(undefined)
                             }
                         }}
                         showTime={hasHours()}
        />
    } 
        return <div>
            {convertDateToFormattedString(localDateTime, props.format ?? DEFAULT_DATE_PATTERN)}
        </div>;
    
};

export default InstantComponent;